function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Checkbox from "react-bootstrap/es/Checkbox";
import { helpers } from '../../common/helpers';

const FilterSidePanelCategoryItem = (_ref) => {
  let {
    children,
    className,
    icon,
    count
  } = _ref,
      props = _objectWithoutProperties(_ref, ["children", "className", "icon", "count"]);

  const classes = classNames('filter-panel-pf-category-item', className);
  return React.createElement("div", {
    className: classes
  }, React.createElement(Checkbox, props, icon && React.createElement("span", {
    className: "item-icon"
  }, icon), children, Number.isInteger(count) && React.createElement("span", {
    className: "item-count"
  }, `(${count})`)));
};

FilterSidePanelCategoryItem.propTypes = _objectSpread({
  /** Children nodes */
  children: PropTypes.node,

  /** Additional css classes */
  className: PropTypes.string,

  /** Optional icon (or other) to show before the children */
  icon: PropTypes.node,

  /** Optional count of the items matching the filter */
  count: PropTypes.number
}, helpers.excludeKeys(Checkbox.propTypes, ['className', 'children']));
FilterSidePanelCategoryItem.defaultProps = _objectSpread({
  children: null,
  className: '',
  icon: null,
  count: null
}, helpers.excludeKeys(Checkbox.defaultProps, ['className', 'children']));
export default FilterSidePanelCategoryItem;